import React, { useEffect } from "react";
import { InputBase, IconButton, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "./AnimatedSearchBar.css";

function SearchBar({
  searchTerm,
  onChange,
  forceExpanded = false,
  placeholderText = "Search...",
}) {
  // Add forceExpanded prop with default value false
  const [isExpanded, setIsExpanded] = React.useState(false);
  const theme = useTheme();

  // Handle local input changes
  const handleSearchChange = (event) => {
    onChange(event.target.value); // Call the parent's onChange handler to update state in parent
  };

  // If forceExpanded is true, ensure the search bar is always expanded
  useEffect(() => {
    if (forceExpanded) {
      setIsExpanded(true);
    }
  }, [forceExpanded]);

  return (
    <div
      className={`search-bar-container ${isExpanded ? "expanded" : ""}`}
      onMouseEnter={() => !forceExpanded && setIsExpanded(true)} // Only expand on hover if not forced
      onMouseLeave={() => !forceExpanded && setIsExpanded(false)} // Only collapse on hover out if not forced
    >
      <IconButton
        onClick={() => setIsExpanded(true)} // Always allow manual expansion
        style={{
          color: isExpanded
            ? theme.palette.success.text
            : theme.palette.info.main,
        }}
      >
        <FontAwesomeIcon icon={faSearch} />
      </IconButton>
      <InputBase
        value={searchTerm} // Use the searchTerm from props
        onChange={handleSearchChange} // Handle changes using local handler
        className={`search-input ${isExpanded ? "visible" : "hidden"}`}
        placeholder={placeholderText}
        style={{ color: theme.palette.success.text }}
      />
    </div>
  );
}

export default SearchBar;
